import { useNavigate } from "react-router-dom";

export const useWithdrawCard = () => {
    const navigate = useNavigate()
    const faqs = [
        {
            question: "Quem pode sacar o limite do cartão consignado?",
            answer: "Clientes que possuem o cartão de crédito consignado BMG, geralmente aposentados, pensionistas do INSS e servidores públicos.",
        },
        {
            question: "O saque tem consulta ao SPC/Serasa?",
            answer: "Não. Se você já tem o cartão consignado, não há nova análise de crédito.",
        },
        {
            question: "Tem taxa para sacar?",
            answer: "Há cobrança de juros do cartão consignado, mas geralmente a taxa é menor que empréstimos pessoais. ",
        },
        {
            question: "Qual a diferença entre sacar e usar o cartão para compras?",
            answer: "O saque transforma o limite do cartão em dinheiro na conta; a compra usa o limite diretamente em estabelecimentos.",
        },
    ]

    const getSubHeader = () => (<section style={{ zIndex: 5 }} className="hidden md:flex bg-[#462A71] w-full px-4 py-2 flex items-center justify-center gap-5 fixed">
        <a href="#AdvantagesOfWithdrawal" className="text-white hover:opacity-[0.7] text-sm">Vantagens do saque</a>
        <a href="#WhyWithdraw" className="text-white hover:opacity-[0.7] text-sm">Por que sacar o limite do cartão?</a>
        <a href="#HowToDoIt" className="text-white hover:opacity-[0.7] text-sm">Como fazer o saque?</a>
        <a href="#Faq" className="text-white hover:opacity-[0.7] text-sm">Ajuda</a>
    </section>)

    const onGoToRegister = () => navigate('/register');

    return {
        faqs,
        getSubHeader,
        onGoToRegister
    }
}